export const useDataEnv = () => window.data_env;

export const useFeatures = () => useDataEnv()?.features;